import * as React from 'react'
import { SystemAnchorList } from '../tools/SystemAnchorList';
import { SystemLink } from '../tools/SystemLink';
import { Link } from 'react-router-dom';
interface ISystemNavDropdown {
    className?: string,
    dropdownMenuclassName?: string,
    dropdownId: string,
    iconName?: string,
    dropdownSubMenuTitle?: any,
    notificationTitle?: string,
    children: any,
    badgeCount?: string,
    langIcon?: boolean
}

export const SystemNavDropdown = (props: ISystemNavDropdown) => {
    return (
        <>
            <li className={["dropdown", props.className].join(" ")}>
                <a id={props.dropdownId} to="" className="nav-link b-l pl-lg-3 pr-lg-3" data-toggle="dropdown" aria-expanded="false" aria-haspopup="true">
                    <span className={props.iconName}></span>
                    <span className="badge badge-danger badge-mini rounded-circle">{props.badgeCount}</span>
                </a>
                <ul className={["dropdown-menu", props.dropdownMenuclassName].join(" ")} aria-labelledby={props.dropdownId}>
                    {props.notificationTitle ? <li className="header">{props.notificationTitle}</li> : null}
                    <li>
                        <ul className="menu">
                            {props.children}
                        </ul>
                    </li>
                    {props.notificationTitle ? <li className="footer p-2 text-center"><SystemLink to="">View all</SystemLink></li> : null}
                </ul>
            </li>
        </>
    )
}


